import { useRecoilValueLoadable } from 'recoil';
export const useIsLoading = ({ state, }) => {
    const responseLoadable = useRecoilValueLoadable(state);
    return responseLoadable.state === 'loading';
};
export default useIsLoading;
//# sourceMappingURL=use-is-loading.js.map